import { render, staticRenderFns } from "./VRHeader.vue?vue&type=template&id=4cc11af6"
import script from "./VRHeader.vue?vue&type=script&lang=js"
export * from "./VRHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports